import React from "react"
import { SpeedInsights } from "@vercel/speed-insights/next"
import { Analytics } from "@vercel/analytics/next"

const isProd = process.env.IS_PROD === "true"

const QualityTools = () => {
	if (!isProd) return null
	return (
		<>
			<SpeedInsights
				// beforeSend={(event) => {
				// 	console.log('si:', event);
				// 	// Replace this with your logic to check usage
				// 	// const hasReachedLimit = checkUsageLimit();
				// 	// if (hasReachedLimit) {
				// 	// 	return null; // Cancel the event
				// 	// }
				// 	return event;
				// }}
				sampleRate={0.05}
			/>
			<Analytics
			// beforeSend={(event) => {
			// 	console.log('a:', event);
			// 	// Replace this with your logic to check usage
			// 	// const hasReachedLimit = checkUsageLimit();
			// 	// if (hasReachedLimit) {
			// 	// 	return null; // Cancel the event
			// 	// }
			// 	return event;
			// }}
			/>
		</>
	)
}

export default QualityTools
